import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  Text,
  Grid,
  GridItem,
  useTheme,
  Alert,
  AlertIcon,
  AlertDescription,
  VStack,
  Center,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { VaccineStock } from "./dashboard/VacineStock";
import { VaccineStockExp } from "./dashboard/VacineStockExp";
import { VaccineOrdersStackedBar } from "./dashboard/VaccineOrdersStackedBar";
import { ProductionAndDeliveryChart } from "./dashboard/ProductionAndDeliveryChart";
import { VaccineDemandPieChart } from "./dashboard/VaccineDemandPieChart";
import Header from "../components/Header";
import InventorySummaryTable from "./dashboard/InventorySummaryTable";
import { InventoryBarChart } from "./dashboard/InventoryBarChart";
import { InventoryPieChart } from "./dashboard/InventoryPieChart";
import VaccineRecReq from "./dashboard/VaccineRecReq";
import VaccineDistribution from "./dashboard/VaccineDistribution";
import { LivestockAmountPieChart } from "./dashboard/LivestockAmountPieChart";
import VaccineInfographic from "./VaccineInfographic";
import { useAuth } from "../context/AuthContext";
import apiService from "../services/ApiService";

const Dashboard = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { sessionId } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchNotifications = async () => {
    setIsLoading(true);
    try {
      const response = await apiService({
        method: "POST",
        url: "/getNotificationList",
        data: {},
        sessionId: sessionId || "",
      });
      if (response.result === "success") {
        setNotifications(response.notifications || []);
      } else {
        console.error("Failed to fetch notifications:", response.error);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (sessionId) {
      fetchNotifications();
    }
  }, [sessionId]);

  return (
    <>
      <Box>
        <Header />
      </Box>
      <Box w="full">
        {notifications.length > 0 && (
          <Box p={4} borderRadius="md" boxShadow="md" ml={10} mr={10} mb={5}>
            <Heading size="md" mb={4}>
              การแจ้งเตือน
            </Heading>
            <VStack spacing={3} align="stretch">
              {notifications.map((notification, index) => (
                <Alert key={index} status="info" borderRadius="md">
                  <AlertIcon />
                  <AlertDescription>{notification.message}</AlertDescription>
                </Alert>
              ))}
            </VStack>
          </Box>
        )}

        <Box p={4} borderRadius="md" boxShadow="md" ml={10} mr={10}>
          <VaccineInfographic />
        </Box>

        <Grid templateColumns={{ base: "1fr", sm: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }} gap={{ base: 4, md: 6, lg: 6 }} m={5}>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Center>
              <VaccineDistribution />
            </Center>
          </GridItem>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
              <Center>
              <VaccineRecReq />
            </Center>
          </GridItem>
        </Grid>
{/*
        <Grid templateColumns={{ base: "1fr", sm: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }} gap={{ base: 4, md: 6, lg: 6 }} m={5}>
          {['โคนม','โคเนื้อ','กระบือ','ไก่','เป็ด','สุกร'].map((type, idx) => (
            <GridItem key={idx} bg="white" p={4} borderRadius="md" boxShadow="md">
              <Center>
                <LivestockAmountPieChart livestockType={type} />
              </Center>
            </GridItem>
          ))}
        </Grid>
        
        <Grid templateColumns={{ base: "1fr", md: "repeat(1, 1fr)", lg: "repeat(2, 1fr)" }} gap={{ base: 4, md: 6, lg: 6 }} m={5}>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Center>
              <VaccineOrdersStackedBar />
            </Center>
          </GridItem>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Center>
              <ProductionAndDeliveryChart />
            </Center>
          </GridItem>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Center>
              <VaccineStockExp />
            </Center>
          </GridItem>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Center>
              <VaccineDemandPieChart type="pig" />
            </Center>
          </GridItem>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Center>
              <VaccineDemandPieChart type="cow" />
            </Center>
          </GridItem>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Center>
              <VaccineDemandPieChart type="poultry" />
            </Center>
          </GridItem>
        </Grid>

        <Grid templateColumns={{ base: "1fr", md: "repeat(1, 1fr)", lg: "repeat(2, 1fr)" }} gap={{ base: 4, md: 6, lg: 6 }} m={5}>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Box mb={5}>
              <Text fontSize="xl" fontWeight="bold" mb={4}>
                สรุปการใช้วัคซีน
              </Text>
              <Center>
                <InventorySummaryTable />
              </Center>
            </Box>
          </GridItem>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Box mb={5}>
              <Text fontSize="xl" fontWeight="bold" mb={4}>
                สรุปการใช้วัคซีน
              </Text>
              <Center>
                <InventoryBarChart />
              </Center>
            </Box>
          </GridItem>
          <GridItem bg="white" p={4} borderRadius="md" boxShadow="md">
            <Box mb={5}>
              <Text fontSize="xl" fontWeight="bold" mb={4}>
                สรุปการใช้วัคซีน
              </Text>
              <Center>
                <InventoryPieChart />
              </Center>
            </Box>
          </GridItem>
        </Grid>
*/}
      </Box>
    </>
  );
};

export default Dashboard;
